import { FEED_MAP } from './constants';

export const isPlaylistAdvertSelectable = ({
  advert,
  outputName,
  eventHomeClubId,
  userClubId,
  eventCompetitionId,
}) => {
  const isPlanningPlaceholder =
    (advert.is_placeholder === true || Number(advert.is_placeholder) === 1) &&
    Number(userClubId) === 1 &&
    Number(eventCompetitionId) >= 10;

  if (
    Number(advert.club_id) !== Number(userClubId) ||
    !advert.active ||
    (advert.approved === false && !isPlanningPlaceholder)
  ) {
    return false;
  }

  if (!advert.feeds?.length) return true;

  const feedCode = FEED_MAP[outputName];
  if (feedCode && !advert.feeds.includes(feedCode)) return false;

  return !(
    Number(userClubId) > 1 &&
    Number(eventHomeClubId) === Number(userClubId) &&
    outputName.includes('Away RSN') &&
    !advert.feeds.includes('S')
  );
};
